module.exports = __webpack_public_path__ + "static/media/pilotu.a788d5f8.png";